export default {
  materials: [
    {
      code: "EPDM",
      name: "EPDM (에틸렌-프로필렌 고무)",
      fullName: "Ethylene Propylene Diene Monomer",
      icon: "ri-sun-line",
      color: "bg-accent-500",
      properties: {
        내열성: "★★★★★ (최대 150℃)",
        내한성: "★★★★☆ (-50℃)",
        내후성: "★★★★★",
        내오존성: "★★★★★",
        내유성: "★☆☆☆☆",
        내마모성: "★★★☆☆",
        인장강도: "★★★☆☆ (8~20 MPa)",
      },
      features: [
        "내열성, 내후성, 내오존성이 매우 우수",
        "전기절연성이 뛰어남",
        "극성 용제에 대한 저항성 우수",
        "저온에서도 유연성 유지",
      ],
      applications: ["자동차 웨더스트립", "건축용 실링 가스켓", "열교환기 가스켓", "냉각수 호스", "전선 피복"],
      desc: "가장 널리 사용되는 범용 고무 소재로, 특히 옥외 환경과 고온 환경에서 탁월한 성능을 발휘합니다. 내후성과 내오존성이 뛰어나 장기간 햇빛과 오존에 노출되는 환경에 적합합니다.",
    },
    {
      code: "NBR",
      name: "NBR (니트릴 고무)",
      fullName: "Acrylonitrile Butadiene Rubber",
      icon: "ri-oil-line",
      color: "bg-primary-500",
      properties: {
        내열성: "★★★★☆ (최대 120℃)",
        내한성: "★★☆☆☆ (-30℃)",
        내후성: "★★☆☆☆",
        내오존성: "★★☆☆☆",
        내유성: "★★★★★",
        내마모성: "★★★★☆",
        인장강도: "★★★★☆ (10~25 MPa)",
      },
      features: [
        "내유성과 내용제성이 탁월",
        "기계적 강도와 내마모성 우수",
        "아크릴로니트릴 함량 조절로 물성 조정 가능",
        "가스 투과성이 낮음",
      ],
      applications: ["오일씰, 연료호스", "유압기기 패킹", "산업용 롤러", "연료탱크 가스켓", "내유성 패킹"],
      desc: "내유성이 요구되는 환경에서 가장 많이 사용되는 고무 소재입니다. 아크릴로니트릴(ACN) 함량에 따라 내유성과 내한성의 균형을 조절할 수 있어 다양한 오일 및 연료 환경에 대응 가능합니다.",
    },
    {
      code: "CR",
      name: "CR (클로로프렌 고무)",
      fullName: "Chloroprene Rubber (Neoprene)",
      icon: "ri-fire-line",
      color: "bg-secondary-500",
      properties: {
        내열성: "★★★★☆ (최대 120℃)",
        내한성: "★★★☆☆ (-40℃)",
        내후성: "★★★★☆",
        내오존성: "★★★★☆",
        내유성: "★★★☆☆",
        내마모성: "★★★★☆",
        인장강도: "★★★★☆ (15~25 MPa)",
      },
      features: [
        "내후성, 내오존성, 내열성 균형 우수",
        "난연성이 있어 화재 안전 요구 환경에 적합",
        "접착성이 좋아 금속과의 접합에 유리",
        "내유성과 내약품성 보유",
      ],
      applications: ["방진 고무", "컨베이어 벨트", "건축용 가스켓", "케이블 시스", "접착제"],
      desc: "균형 잡힌 물성을 가진 다목적 고무 소재입니다. 특히 난연성을 갖추고 있어 건축, 선박, 광산 등 화재 안전이 중요한 환경에서 널리 사용됩니다.",
    },
    {
      code: "SBR",
      name: "SBR (스티렌 부타디엔 고무)",
      fullName: "Styrene Butadiene Rubber",
      icon: "ri-caravan-line",
      color: "bg-foreground-500",
      properties: {
        내열성: "★★★☆☆ (최대 100℃)",
        내한성: "★★★☆☆ (-50℃)",
        내후성: "★★☆☆☆",
        내오존성: "★★☆☆☆",
        내유성: "★☆☆☆☆",
        내마모성: "★★★★★",
        인장강도: "★★★☆☆ (5~20 MPa)",
      },
      features: ["내마모성이 매우 우수", "가공성과 경제성이 뛰어남", "충진제 배합으로 물성 조절 용이", "가격 경쟁력 우수"],
      applications: ["타이어 트레드", "신발 밑창", "컨베이어 벨트", "일반 산업용 고무제품", "방진 패드"],
      desc: "가장 경제적인 범용 고무 소재로, 특히 내마모성이 요구되는 용도에 적합합니다. 천연고무의 대체 소재로 널리 사용되며, 카본블랙 배합을 통해 기계적 물성을 크게 향상시킬 수 있습니다.",
    },
    {
      code: "FKM",
      name: "FKM (불소 고무 / Viton)",
      fullName: "Fluoroelastomer (Viton®)",
      icon: "ri-test-tube-line",
      color: "bg-accent-500",
      properties: {
        내열성: "★★★★★ (최대 250℃)",
        내한성: "★★☆☆☆ (-20℃)",
        내후성: "★★★★★",
        내오존성: "★★★★★",
        내유성: "★★★★★",
        내마모성: "★★★☆☆",
        인장강도: "★★★☆☆ (8~15 MPa)",
      },
      features: [
        "초고온·극한 화학 환경에서 최고 성능",
        "거의 모든 화학물질에 대한 내성 보유",
        "장기 내구성과 신뢰성 최상",
        "진공 환경에서도 아웃가싱 최소",
      ],
      applications: ["화학플랜트 씰", "반도체 장비 씰", "항공우주 부품", "고온 밸브 시트", "원자력 설비 가스켓"],
      desc: "극한의 온도와 화학 환경을 견디는 최고급 특수 고무 소재입니다. 가격은 높지만 타 소재로 대체 불가능한 극한 환경에서 필수적으로 사용됩니다. 당사는 FKM 소재의 압축성형에 특화된 생산라인을 운영하고 있습니다.",
    },
    {
      code: "VMQ",
      name: "실리콘 고무 (VMQ)",
      fullName: "Silicone Rubber (VMQ)",
      icon: "ri-cpu-line",
      color: "bg-secondary-500",
      properties: {
        내열성: "★★★★★ (최대 230℃)",
        내한성: "★★★★★ (-100℃)",
        내후성: "★★★★★",
        내오존성: "★★★★★",
        내유성: "★★☆☆☆",
        내마모성: "★★☆☆☆",
        인장강도: "★★☆☆☆ (4~10 MPa)",
      },
      features: [
        "극저온~고온까지 가장 넓은 사용 온도 범위",
        "생체 적합성 우수 (의료용 등급)",
        "전기 절연성 탁월",
        "투명/반투명 성형 가능",
      ],
      applications: ["의료기기 부품", "전기전자 절연 씰", "식품가공 장비 패킹", "방수 씰 (IP67/68)", "베이비 케어 제품"],
      desc: "인체 무해성과 넓은 사용 온도 범위가 특징인 고기능성 소재입니다. 의료, 식품, 전기전자 등 고순도가 요구되는 분야에서 필수적으로 사용되며, 당사는 식품 등급 및 의료 등급 실리콘 고무 성형이 가능합니다.",
    },
  ],
  quotationGuide: {
    title: "견적문의 안내",
    desc: "고객님의 요구사항을 정확히 파악하여 최적의 견적을 신속하게 제공해 드립니다. 아래 항목을 기재하여 문의해 주시면 보다 정확한 견적 산출이 가능합니다.",
    requiredInfo: [
      "제품 도면 또는 스케치 (PDF, DWG, JPG 가능)",
      "필요 수량 (월 예상 소요량)",
      "적용 환경 (온도, 접촉 유체, 압력 등)",
      "요구 물성 (경도, 인장강도, 내열온도 등)",
      "희망 납기",
    ],
    process: [
      { step: 1, title: "문의 접수", desc: "전화, 이메일, 또는 견적문의 게시판을 통한 접수" },
      { step: 2, title: "도면 검토", desc: "엔지니어의 도면/사양 검토 및 소재 추천" },
      { step: 3, title: "견적서 발송", desc: "2~3 영업일 이내 견적서 이메일 발송" },
      { step: 4, title: "협의 및 조정", desc: "수량·납기·사양 협의 및 최종 견적 확정" },
    ],
  },
  page: {
    title: "기술자료",
    subtitle: "고무 소재 전문 지식과 기술 노하우를 공유합니다",
    materialsTab: "고무 재질 소개",
    downloadsTab: "기술자료 다운로드",
    featuresTitle: "주요 특징",
    applicationsTitle: "적용 분야",
    propertiesTitle: "물성 특성",
    inquiryMaterial: "이 소재로 문의하기",
    total: "총 {{count}}건의 자료",
    searchPlaceholder: "자료명, 카테고리 검색",
    empty: "검색 결과가 없습니다.",
    download: "다운로드",
    loading: "불러오는 중...",
    fetchError: "데이터를 불러오지 못했습니다.",
    retry: "다시 시도",
  },
};